"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var Modal = function (_a) {
    var children = _a.children, _b = _a.open, open = _b === void 0 ? true : _b, _c = _a.addClickOutsideListener, addClickOutsideListener = _c === void 0 ? false : _c, onClose = _a.onClose;
    var _d = (0, react_1.useState)(open), modalOpen = _d[0], setModalOpen = _d[1];
    var childrenRef = (0, react_1.useRef)(null);
    var handleClickOutside = function (e) {
        if (!childrenRef.current || childrenRef.current.contains(e.target)) {
            return;
        }
        setModalOpen(function (prevOpen) {
            if (prevOpen && onClose) {
                onClose();
            }
            return false;
        });
    };
    (0, react_1.useEffect)(function () {
        if (!addClickOutsideListener) {
            return;
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () { return document.removeEventListener("mousedown", handleClickOutside); };
    }, []);
    (0, react_1.useEffect)(function () {
        setModalOpen(open);
    }, [open]);
    (0, react_1.useEffect)(function () {
        if (modalOpen) {
            document.body.classList.add("overflow-hidden");
        }
        else {
            document.body.classList.remove("overflow-hidden");
        }
    }, [modalOpen]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)("modal-container", !modalOpen && "modal-container--hidden") }, { children: children(childrenRef) }));
};
exports.default = Modal;
